import React from 'react'

const TraceabilityOperatorHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4473_29175)" />
    <path
      d="M51.6105 44.7718C51.17 42.3808 49.9745 40.4303 48.1498 38.7944C45.8847 36.7809 43.1162 35.5854 40.2218 34.7045C39.5297 34.4528 38.9634 34.5158 38.46 35.082C38.3342 35.2708 38.0825 35.3337 37.9567 35.5225C36.95 36.2775 36.0061 37.0326 34.9994 37.8506C34.8736 37.7247 34.7477 37.6618 34.6848 37.5989C33.4893 36.6551 32.2938 35.7112 31.0983 34.7674C30.9096 34.6416 30.595 34.5158 30.4062 34.5787C27.5748 35.3337 24.8692 36.4663 22.5411 38.291C20.4018 39.9269 18.9546 41.9404 18.3883 44.5831C18.1366 45.9044 18.4512 46.7224 19.5838 47.4145C20.213 47.792 20.8422 48.1696 21.5344 48.4842C24.7433 49.9943 28.141 50.6235 31.6646 50.8751C35.5028 51.1268 39.3409 51.001 43.1162 50.2459C45.7589 49.6797 48.2757 48.8617 50.5408 47.3516C51.5476 46.7224 51.8622 45.9044 51.6105 44.7718ZM36.132 46.4707C35.6286 47.5403 35.6915 47.3516 34.9994 48.4212C34.559 47.7291 34.1814 47.037 33.741 46.4078C33.1747 45.5898 33.1118 44.8977 33.3635 44.0168C33.9298 42.0662 34.4331 40.0528 34.9365 38.0393C34.9994 38.0393 34.9994 38.0393 35.0623 38.0393C35.314 38.9831 35.5657 39.864 35.8174 40.8078C36.1949 42.1921 36.2578 42.3808 36.6353 43.7651C37.0758 45.2123 36.4466 45.9044 36.132 46.4707ZM44.3746 44.1426H41.1027C40.851 44.1426 40.5994 43.8909 40.5994 43.6393C40.5994 43.3876 40.851 43.1359 41.1027 43.1359H44.3746C44.6263 43.1359 44.878 43.3876 44.878 43.6393C44.878 43.8909 44.6892 44.1426 44.3746 44.1426Z"
      fill="white"
    />
    <path
      d="M35.0622 33.5719C31.9162 33.4461 29.5252 32.0618 27.9522 29.4192C25.8129 25.9585 26.3792 21.3024 29.2735 18.408C32.5454 15.1362 37.7049 15.1991 40.9139 18.5339C45.3183 23.1271 43.6195 30.9293 37.7049 33.0686C37.3274 33.1944 36.9499 33.3203 36.5094 33.3832C36.006 33.509 35.5027 33.509 35.0622 33.5719Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4473_29175"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default TraceabilityOperatorHome
